import React, { useState } from "react";
import { Layout, Col, Row, Divider, Typography } from "antd";
import Link from "next/link";
import { FaXTwitter } from "react-icons/fa6";
import { FiFacebook } from "react-icons/fi";
import { SlSocialLinkedin } from "react-icons/sl";
import {
  InstagramOutlined,
  YoutubeOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { useRouter } from "next/router";
import SignUpNotifyFormModal from "@/components/LandingPage/SignUpNotifyForm";
const { Footer: AntFooter } = Layout;
const { Text } = Typography;

const Footer: React.FC = () => {
  const router = useRouter();
  const [signUpNotify, setSignUpNotify] = useState<boolean>(false);

  const handleSignUpToNotify = () => {
    setSignUpNotify(!signUpNotify);
  };

  const handleAnchorClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string
  ) => {
    e.preventDefault();
    if (href.startsWith("#")) {
      if (router.pathname !== "/") {
        router.push({
          pathname: "/",
          query: { scrollTo: href.substring(1) },
        });
      } else {
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          const navbarHeight =
            document.querySelector("header")?.offsetHeight || 0;
          window.scrollTo({
            top: targetElement.offsetTop - navbarHeight,
            behavior: "smooth",
          });
          window.history.pushState(null, "", href);
        }
      }
    } else {
      router.push(href);
    }
  };

  return (
    <AntFooter className="bg-[#2D68C4] text-white pt-10 pb-4">
      <div className="container mx-auto">
        <Row gutter={[24, 16]}>
          <Col xs={24} md={8} className="mb-6">
            <h2 className="text-xl font-semibold mb-2">StedPrep</h2>
            <p className="text-gray-100 text-sm w-full">
              We respect your privacy - we are parents as well - no spam, ever.
            </p>
            <div className="flex mt-4 space-x-4">
              <Link
                href="#"
                className="bg-blue-500 p-2 rounded-full flex items-center justify-center w-9 h-9 text-white hover:bg-white hover:text-blue-500 transition-colors"
              >
                <SlSocialLinkedin className="text-lg" />
              </Link>
              <Link
                href="#"
                className="bg-blue-500 p-2 rounded-full flex items-center justify-center w-9 h-9 text-white hover:bg-white hover:text-blue-500 transition-colors"
              >
                <FaXTwitter className="text-lg" />
              </Link>
              <Link
                href="#"
                className="bg-blue-500 p-2 rounded-full flex items-center justify-center w-9 h-9 text-white hover:bg-white hover:text-blue-500 transition-colors"
              >
                <YoutubeOutlined className="text-lg" />
              </Link>
              <Link
                href="#"
                className="bg-blue-500 p-2 rounded-full flex items-center justify-center w-9 h-9 text-white hover:bg-white hover:text-blue-500 transition-colors"
              >
                <FiFacebook className="text-lg" />
              </Link>
              <Link
                href="#"
                className="bg-blue-500 p-2 rounded-full flex items-center justify-center w-9 h-9 text-white hover:bg-white hover:text-blue-500 transition-colors"
              >
                <InstagramOutlined className="text-lg" />
              </Link>
            </div>

            <div className="mt-4">
              <Link
                target="_blank"
                href="https://mail.google.com/mail/?view=cm&to=hello@stedprep.com"
                className="text-white hover:underline hover:underline-offset-4"
              >
                <MailOutlined className="text-md mr-4 ml-2" />
                hello@stedprep.com
              </Link>
            </div>
          </Col>

          <Col xs={24} md={5} className="mb-6 md:ml-20">
            <h3 className="text-lg font-medium mb-4 text-white">Exams</h3>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="#stedprep-exam-preparation"
                  onClick={(e) =>
                    handleAnchorClick(e, "#stedprep-exam-preparation")
                  }
                  className="text-white opacity-80 hover:opacity-100 transition-opacity hover:underline hover:underline-offset-4 cursor-pointer"
                >
                  ISEE Middle Level
                </a>
              </li>
              <li>
                <a
                  href="#stedprep-exam-preparation"
                  onClick={(e) =>
                    handleAnchorClick(e, "#stedprep-exam-preparation")
                  }
                  className="text-white opacity-80 hover:opacity-100 transition-opacity hover:underline hover:underline-offset-4 cursor-pointer"
                >
                  ISEE Upper Level
                </a>
              </li>
              <li>
                <a
                  href="#stedprep-exam-preparation"
                  onClick={(e) =>
                    handleAnchorClick(e, "#stedprep-exam-preparation")
                  }
                  className="text-white opacity-80 hover:opacity-100 transition-opacity hover:underline hover:underline-offset-4 cursor-pointer"
                >
                  SSAT
                </a>
              </li>
              <li>
                <a
                  href="#stedprep-exam-preparation"
                  onClick={(e) =>
                    handleAnchorClick(e, "#stedprep-exam-preparation")
                  }
                  className="text-white opacity-80 hover:opacity-100 transition-opacity hover:underline hover:underline-offset-4 cursor-pointer"
                >
                  SAT
                </a>
              </li>
            </ul>
          </Col>

          <Col xs={24} md={6} className="mb-6">
            <h3 className="text-lg font-medium mb-4 text-white">Company</h3>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="#stedprep-how-was-it-born"
                  onClick={(e) =>
                    handleAnchorClick(e, "#stedprep-how-was-it-born")
                  }
                  className="text-white opacity-80 hover:opacity-100 transition-opacity hover:underline hover:underline-offset-4"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#stedprep-partner-with-us"
                  onClick={(e) =>
                    handleAnchorClick(e, "#stedprep-partner-with-us")
                  }
                  className="text-white opacity-80 hover:opacity-100 transition-opacity hover:underline hover:underline-offset-4"
                >
                  Partner with Us
                </a>
              </li>
              <li>
                <Link
                  href="/privacy-policy"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(
                      "/privacy-policy",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                  className="text-white opacity-80 hover:opacity-100 transition-opacity hover:underline hover:underline-offset-4"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  href="/terms-and-conditions"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(
                      "/terms-and-conditions",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                  className="text-white opacity-80 hover:opacity-100 transition-opacity hover:underline hover:underline-offset-4"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  href="/refund-policy"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(
                      "/refund-policy",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                  className="text-white opacity-80 hover:opacity-100 transition-opacity hover:underline hover:underline-offset-4"
                >
                  Refund Policy
                </Link>
              </li>
            </ul>
          </Col>
        </Row>

        <Divider className="bg-[#ffffff] my-6 opacity-100 mb-0" />

        <div className="flex flex-col lg:flex-row justify-between items-center">
          <Text style={{ color: "rgba(255, 255, 255, 0.8)", fontSize: "14px" }}>
            © 2025 StedPrep. All rights Reserved
          </Text>
          <Text
            style={{
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: "14px",
              marginTop: "8px",
              marginLeft: 0,
            }}
            className="md:mt-0"
          >
            {`Built by parents, for parents`}
          </Text>
        </div>
      </div>
      {signUpNotify && (
        <SignUpNotifyFormModal
          signUpNotify={signUpNotify}
          handleSignUpToNotify={handleSignUpToNotify}
        />
      )}
    </AntFooter>
  );
};

export default Footer;
